import React from 'react';
import classNames from 'clsx';

import { useApplicationParams } from '../../context';

const ProductImage = ({ data: productImage }) => {
  const { isWeb } = useApplicationParams();

  const imageClassName = classNames('product-details-img', {
    'product-details-img-lg': isWeb,
  });

  return <img src={productImage} alt="" className={imageClassName} />;
};

export default ProductImage;
